<template>
  <div class="" style="width: 100%;">
    <div class="content">
      <div class="rich-text-content" style="word-wrap: break-word; word-break: break-all;"
        v-html="$Tools.handlerImg(agreementInfo.content)"></div>
    </div>

    <!-- <moe-bottom></moe-bottom> -->
  </div>
</template>

<script>
export default {
  name: "GjkcH5Agreement",

  data() {
    return {
      type: "",
      agreementInfo: {},
    };
  },

  mounted() {
    this.type = this.$Jump.getUrlParams(
      window.location.hash.split("?")[1]
    ).type;
    this.getAgreement();
  },

  methods: {
    getAgreement() {
      this.$Api.login.getAgreement(this.type).then((res) => {
        this.agreementInfo = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 0 20px;
  font-size: 14px;
  color: #666666;
  line-height: 28px;
  word-wrap: break-word;
  // height: 450px;
  // overflow: auto;
  width: $pageMainWidth;
  box-sizing: border-box;

  // margin: 0 auto;
  .rich-text-content {
    max-width: 100%;
  }
}
</style>